// extracted by mini-css-extract-plugin
export default {"metadataField":"InputField_metadataField__XEZQJ"};